import {EventEmitter, Injectable, Output} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedTeamNameChangeService {
  private teamNameSource = new BehaviorSubject<string | null>(null);
  teamName$ = this.teamNameSource.asObservable();

  setTeamName(name: string | null) {
    this.teamNameSource.next(name);
  }

}
